import React from 'react'

export const Logo = ({ isLogin }) => {
  return (
    <img
      alt={process.env.REACT_APP_CUSTOMER_NAME}
      src={
        isLogin
          ? require('../../assets/img/logo.png')
          : require('../../assets/img/logoNav.png')
      }
    />
  )
}
